import domain from "./domain";

// Reset teams
export const resetTeams = domain.createEvent('resetTeams');
